import { Button, Heading, Section } from 'components'
import { graphql, useStaticQuery } from 'gatsby'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import React from 'react'

const CaseStudies = ({
  kicker,
  heading,
  text,
  buttons,
  image,
  embed,
  backgroundColor,
}) => {
  const {
    allFile: { edges: images },
  } = useStaticQuery(graphql`
    {
      allFile(filter: { sourceInstanceName: { eq: "images" } }) {
        edges {
          node {
            name
            url
            publicURL
            childImageSharp {
              gatsbyImageData(width: 1200, quality: 99)
            }
          }
        }
      }
    }
  `)

  const [imageUrl] = images.filter((imageUrl) => {
    return imageUrl.node.name === image.title
  })

  return (
    <Section background={backgroundColor} padding="p-0">
      <div
        className={`grid grid-cols-12 items-center gap-16 overflow-hidden row-start-1 ${
          image.align === 'left' ? 'col-start-6' : 'col-start-1'
        }`}
      >
        <div className="space-y-8 col-span-4 py-16">
          <Heading type="kicker">{kicker}</Heading>
          <Heading>
            <div>{heading}</div>
          </Heading>
          {/* <ParsedContent className="text-gray-500">{text}</ParsedContent> */}

          <div className="flex flex-wrap w-full">
            {buttons.map((button) => (
              <Button
                key={button.label}
                type={button.type}
                to={button.destination.uri}
              >
                {button.label}
              </Button>
            ))}
          </div>
        </div>

        <div
          className={`col-span-8 self-end row-start-1 flex ${
            image.align === 'left' ? 'col-start-1' : 'col-start-5'
          }`}
        >
          {imageUrl && (
            <div className="flex transform translate-y-28  overflow-hidden">
              {!imageUrl.node.childImageSharp ? (
                <img
                  src={imageUrl.node.publicURL}
                  alt={
                    imageUrl.node.altText
                      ? imageUrl.node.altText
                      : imageUrl.node.title
                  }
                ></img>
              ) : (
                <GatsbyImage
                  objectFit="cover"
                  alt={
                    imageUrl.node.altText
                      ? imageUrl.node.altText
                      : imageUrl.node.title
                  }
                  image={getImage(imageUrl.node)}
                />
              )}
            </div>
          )}

          {/* {embed && (
            <ParsedContent className="text-gray-500">{embed}</ParsedContent>
          )} */}
        </div>
      </div>
    </Section>
  )
}

export default CaseStudies
